import { useQuery, useLazyQuery } from '@apollo/client';
import { graphql } from '../gql/__codegen__';
import type {
  Shared_CurrentBillingMethodQuery,
  Shared_CurrentBillingMethodQueryVariables,
} from '../gql/__codegen__/graphql';
import type { LazyQueryHookOptions, QueryHookOptions } from '@apollo/client';

const QUERY = graphql(`
  query shared_currentBillingMethod {
    unextAccount {
      currentBillingMethod {
        __typename
        ... on PaymentCardInfo {
          id
          cardNumber
          cardExpiryDate
          cardholderName
          paymentCardInfoCardType: cardType
        }
        ... on SbpsV2PaymentInfo {
          id
          code
          sbpsV2PaymentInfoName: name
        }
        ... on BasicPaymentInfo {
          id
          basicPaymentInfoName: name
        }
        ... on CreditCardInfo {
          id
          creditCardInfoName: name
          creditCardInfoCardType: cardType
        }
        ... on MobilePaymentInfo {
          id
          mobilePaymentInfoName: name
        }
      }
    }
  }
`);

type HookOptions = QueryHookOptions<
  Shared_CurrentBillingMethodQuery,
  Shared_CurrentBillingMethodQueryVariables
>;

export function useCurrentBillingMethodQuery(options?: HookOptions) {
  return useQuery(QUERY, options);
}

type LazyHookOptions = LazyQueryHookOptions<
  Shared_CurrentBillingMethodQuery,
  Shared_CurrentBillingMethodQueryVariables
>;

export function useCurrentBillingMethodLazyQuery(options?: LazyHookOptions) {
  return useLazyQuery(QUERY, options);
}
